export default __webpack_public_path__ + "static/media/b24.40b925cb.png";